import { MailOutlined } from '@ant-design/icons';
import { Button, Form, Input } from 'antd';
import { useIntl } from 'react-intl';
import { messages } from './messages';

interface StartupEmailStepProps {
  email: string;
  isEmailValid: boolean;
  onChange: (email: string) => void;
  onSubmit: () => void;
}

export function StartupEmailStep({ email, isEmailValid, onChange, onSubmit }: StartupEmailStepProps) {
  const intl = useIntl();
  return (
    <Form layout="vertical" onFinish={onSubmit}>
      <Form.Item label={intl.formatMessage(messages.appAuthPageEmail)} required>
        <Input
          autoComplete="email"
          inputMode="email"
          onChange={event => onChange(event.target.value)}
          placeholder={intl.formatMessage(messages.appAuthPageEmailPlaceholder)}
          prefix={<MailOutlined />}
          size="large"
          type="email"
          value={email}
        />
      </Form.Item>
      <Button block disabled={!isEmailValid} htmlType="submit" size="large" type="primary">
        {intl.formatMessage(messages.appCommonContinue)}
      </Button>
    </Form>
  );
}
